import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Environment } from '../../../environments/environment';
export function emailDomainValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (!control.value || typeof control.value !== 'string') {
			return null;
		}

		const email: string = control.value;
		const emailParts: string[] = email.split('@');

		if (emailParts.length !== 2) {
			return { invalidEmail: true };
		}

		const domain: string = emailParts[1].toLowerCase();
		const env: Environment = new Environment();
		const allowedDomains: string[] = env.getConfiguration().allowedEmailDomains;

		const isAllowed: boolean = allowedDomains.some(allowedDomain => domain === allowedDomain.toLowerCase());

		return isAllowed ? null : { invalidDomain: { value: domain, allowedDomains } };
	};
}
